import i18next from 'i18next';

const tsFeedbackMap = {
    STRAINED_1: 'ts.strained.feedback.STRAINED_1',
    STRAINED_2: 'ts.strained.feedback.STRAINED_2',
    STRAINED_3: 'ts.strained.feedback.STRAINED_3',
    STRAINED_4: 'ts.strained.feedback.STRAINED_4',
    STRAINED_5: 'ts.strained.feedback.STRAINED_5'
};

export default {
    TrainingStatusTypes: {
        '0': 'NO_STATUS',
        '1': 'DETRAINING',
        '2': 'UNPRODUCTIVE',
        '3': 'OVERREACHING',
        '4': 'MAINTAINING',
        '5': 'RECOVERY',
        '6': 'PEAKING',
        '7': 'PRODUCTIVE',
        '8': 'STRAINED'
    },

    mapStatusLoadPhraseKey: function(trainingStatus, loadFocus) {
        var phraseBuckets = {
            NO_STATUS: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.no.status.feedback.phrase',
                    AER_LOW_SHORT: 'load.focus.no.status.feedback.phrase',
                    AER_HIGH_SHORT: 'load.focus.no.status.feedback.phrase',
                    ANAER_SHORT: 'load.focus.no.status.feedback.phrase',
                    BALANCED: 'load.focus.no.status.feedback.phrase',
                    AER_LOW_FOCUS: 'load.focus.no.status.feedback.phrase',
                    AER_HIGH_FOCUS: 'load.focus.no.status.feedback.phrase',
                    ANAER_FOCUS: 'load.focus.no.status.feedback.phrase',
                    ABOVE_TARGETS: 'load.focus.no.status.feedback.phrase'
                };
            },
            DETRAINING: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.detraining.feedback.phrase',
                    AER_LOW_SHORT: 'load.focus.detraining.feedback.phrase',
                    AER_HIGH_SHORT: 'load.focus.detraining.feedback.phrase',
                    ANAER_SHORT: 'load.focus.detraining.feedback.phrase',
                    BALANCED: 'load.focus.detraining.feedback.phrase',
                    AER_LOW_FOCUS: 'load.focus.detraining.feedback.phrase',
                    AER_HIGH_FOCUS: 'load.focus.detraining.feedback.phrase',
                    ANAER_FOCUS: 'load.focus.detraining.feedback.phrase',
                    ABOVE_TARGETS: 'load.focus.detraining.feedback.phrase'
                };
            },
            UNPRODUCTIVE: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.unproductive.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.unproductive.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.unproductive.feedback.phrase.3',
                    ANAER_SHORT: 'load.focus.unproductive.feedback.phrase.4',
                    BALANCED: 'load.focus.unproductive.feedback.phrase.5',
                    AER_LOW_FOCUS: 'load.focus.unproductive.feedback.phrase.5',
                    AER_HIGH_FOCUS: 'load.focus.unproductive.feedback.phrase.5',
                    ANAER_FOCUS: 'load.focus.unproductive.feedback.phrase.5',
                    ABOVE_TARGETS: 'load.focus.unproductive.feedback.phrase.6'
                };
            },
            OVERREACHING: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.overreaching.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.overreaching.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.overreaching.feedback.phrase.3',
                    ANAER_SHORT: 'load.focus.overreaching.feedback.phrase.3',
                    BALANCED: 'load.focus.overreaching.feedback.phrase.3',
                    AER_LOW_FOCUS: 'load.focus.overreaching.feedback.phrase.3',
                    AER_HIGH_FOCUS: 'load.focus.overreaching.feedback.phrase.2',
                    ANAER_FOCUS: 'load.focus.overreaching.feedback.phrase.2',
                    ABOVE_TARGETS: 'load.focus.overreaching.feedback.phrase.4'
                };
            },
            MAINTAINING: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.maintaining.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.maintaining.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.maintaining.feedback.phrase.2',
                    ANAER_SHORT: 'load.focus.maintaining.feedback.phrase.2',
                    BALANCED: 'load.focus.maintaining.feedback.phrase.3',
                    AER_LOW_FOCUS: 'load.focus.maintaining.feedback.phrase.4',
                    AER_HIGH_FOCUS: 'load.focus.maintaining.feedback.phrase.4',
                    ANAER_FOCUS: 'load.focus.maintaining.feedback.phrase.4',
                    ABOVE_TARGETS: 'load.focus.maintaining.feedback.phrase.5'
                };
            },
            RECOVERY: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.recovery.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.recovery.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.recovery.feedback.phrase.2',
                    ANAER_SHORT: 'load.focus.recovery.feedback.phrase.2',
                    BALANCED: 'load.focus.recovery.feedback.phrase.3',
                    AER_LOW_FOCUS: 'load.focus.recovery.feedback.phrase.3',
                    AER_HIGH_FOCUS: 'load.focus.recovery.feedback.phrase.3',
                    ANAER_FOCUS: 'load.focus.recovery.feedback.phrase.3',
                    ABOVE_TARGETS: 'load.focus.recovery.feedback.phrase.4'
                };
            },
            PEAKING: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.peaking.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.peaking.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.peaking.feedback.phrase.2',
                    ANAER_SHORT: 'load.focus.peaking.feedback.phrase.2',
                    BALANCED: 'load.focus.peaking.feedback.phrase.1',
                    AER_LOW_FOCUS: 'load.focus.peaking.feedback.phrase.1',
                    AER_HIGH_FOCUS: 'load.focus.peaking.feedback.phrase.1',
                    ANAER_FOCUS: 'load.focus.peaking.feedback.phrase.1',
                    ABOVE_TARGETS: 'load.focus.peaking.feedback.phrase.3'
                };
            },
            PRODUCTIVE: function() {
                return {
                    NO_RESULT: '',
                    BELOW_TARGETS: 'load.focus.productive.feedback.phrase.1',
                    AER_LOW_SHORT: 'load.focus.productive.feedback.phrase.2',
                    AER_HIGH_SHORT: 'load.focus.productive.feedback.phrase.2',
                    ANAER_SHORT: 'load.focus.productive.feedback.phrase.2',
                    BALANCED: 'load.focus.productive.feedback.phrase.3',
                    AER_LOW_FOCUS: 'load.focus.productive.feedback.phrase.3',
                    AER_HIGH_FOCUS: 'load.focus.productive.feedback.phrase.3',
                    ANAER_FOCUS: 'load.focus.productive.feedback.phrase.3',
                    ABOVE_TARGETS: 'load.focus.productive.feedback.phrase.4'
                };
            }
        };
        return (phraseBuckets[trainingStatus] || phraseBuckets['NO_STATUS'])()[loadFocus];
    },

    getFeedbackPhrase: function(statusKey, loadFocusKey, phrase) {
        let feedbackPhrase = '';

        if (statusKey === 8) {
            feedbackPhrase = tsFeedbackMap[phrase];
        } else {
            const statusName = this.TrainingStatusTypes[statusKey];
            feedbackPhrase = this.mapStatusLoadPhraseKey(statusName, loadFocusKey);
        }

        return feedbackPhrase ? i18next.t(`reportswidget:${feedbackPhrase}`) : '';
    }
};
